<template>
    <div class="page-content page-cropper-image w-lg p-5 bg-white mb-4">
        <div>
            <div class="flex justify-center">
                <ImageInput
                    :prefill="img"
                    width="150"
                    height="150"
                    style="width: 150px; height: 150px; border-radius: 100%; overflow: hidden"
                    class="bg-gray-100"
                    @change="onChangeImage"
                ></ImageInput>
            </div>

            <Modal v-if="showModal" size="md" @close="onCloseModal" custom-class="modal-cropper-image">
                <div class="px-2 font-semibold">Upload Avatar</div>
                <div class="text-center text-sm pt-5 px-2">
                    <div class="px-4 max-w-[80%] mx-auto d-flex justify-items-center items-center flex-column">
                        <div class="relative">
                            <Cropper
                                :src="img"
                                :stencil-component="stencil"
                                :stencil-props="{
                                    aspectRatio: 1,
                                    resizable: false,
                                    lines: {},
                                    handlers: {},
                                    movable: false,
                                    previewClass: 'cropper__stencil',
                                }"
                                ref="cropper"
                                class="cropper"
                                background-class="cropper__background"
                                foreground-class="cropper__foreground"
                                image-restriction="stencil"
                                default-boundaries="fill"
                                :stencil-size="stencilSize"
                                :transitions="false"
                                :debounce="false"
                                :default-size="defaultSize"
                                :min-width="150"
                                :min-height="150"
                                @change="onChange"
                            ></Cropper>
                        </div>
                        <div class="w-full px-10 flex gap-4 items-center">
                            <span class="range-action" @click="onZoomIn">-</span>
                            <div class="flex-1">
                                <RangeSlider
                                    class="slider"
                                    :min="0"
                                    :max="1"
                                    :value="zoom"
                                    :step="0.01"
                                    @change="onZoom"
                                />
                            </div>
                            <span class="range-action" @click="onZoomOut">+</span>
                        </div>
                    </div>

                    <div class="flex justify-end gap-2 pt-5 px-2">
                        <button class="btn btn-secondary p-4 px-8" @click="onCloseModal">
                            Cancel
                        </button>
                        <button class="btn btn-load btn-success p-4 px-8 bg-red" @click="onCrop">
                            Submit
                        </button>
                    </div>
                </div>
            </Modal>
        </div>
    </div>
</template>
<style>
.cropper {
    height: 400px;
    width: 400px;
    background: #ddd;
}
.cropper .custom-preview {
    border: 2px solid #fff;
}
.cropper__background {
    background-color: #edf2f4;
}
.cropper__foreground {
    background-color: #edf2f4;
}
.cropper__stencil {
    border: solid 5px #fff;
}
.modal-cropper-image .range-slider-knob {
    display: block;
}
.modal-cropper-image .range-slider-fill {
    background-color: red !important;
}
.modal-cropper-image .range-slider-knob:after {
    display: none;
}
.modal-cropper-image .range-slider-knob:before {
    background-color: red;
    bottom: 0;
    margin-top: 0;
    top: -1px;
    height: 15px;
}
.modal-cropper-image .range-action{
    border-radius: 50%;
    background-color: #ff00a8;
    width: 20px;
    height: 20px;
    color: white;
    cursor: pointer;
}
</style>
<script type="text/babel">
import { CircleStencil, Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
import RangeSlider from 'dashboard-js/components/utilities/RangeSlider.vue'
import Modal from 'dashboard-js/components/Modal'
import TextCopy from 'dashboard-js/components/utilities/TextCopy.vue'
export default {
    components: {
        TextCopy,
        RangeSlider,
        Modal,
        Cropper,
    },
    data() {
        return {
            img: 'https://images.unsplash.com/photo-1611162616475-46b635cb6868?q=80&w=3200&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
            stencil: CircleStencil,
            zoom: 0,
            showModal: false,
        }
    },
    methods: {
        defaultSize({ imageSize }) {
            return {
                width: Math.min(imageSize.height, imageSize.width),
                height: Math.min(imageSize.height, imageSize.width),
            }
        },
        stencilSize({ boundaries }) {
            return {
                width: Math.min(boundaries.height, boundaries.width) - 48,
                height: Math.min(boundaries.height, boundaries.width) - 48,
            }
        },
        onChange() {
            const cropper = this.$refs.cropper
            if (cropper) {
                if (cropper.imageSize.height < cropper.imageSize.width) {
                    this.zoom =
                        (cropper.imageSize.height - cropper.coordinates.height) /
                        (cropper.imageSize.height - cropper.sizeRestrictions.minHeight)
                } else {
                    this.zoom =
                        (cropper.imageSize.width - cropper.coordinates.width) /
                        (cropper.imageSize.width - cropper.sizeRestrictions.minWidth)
                }
            }
        },
        onZoom(value) {
            const cropper = this.$refs.cropper
            if (cropper) {
                if (cropper.imageSize.height < cropper.imageSize.width) {
                    const minHeight = cropper.sizeRestrictions.minHeight
                    cropper.zoom(
                        ((1 - this.zoom) * cropper.imageSize.height + minHeight) /
                            ((1 - value) * cropper.imageSize.height + minHeight)
                    )
                } else {
                    const minWidth = cropper.sizeRestrictions.minWidth
                    cropper.zoom(
                        ((1 - this.zoom) * cropper.imageSize.width + minWidth) /
                            ((1 - value) * cropper.imageSize.width + minWidth)
                    )
                }
            }
        },
        onChangeImage(file) {
            this.img = URL.createObjectURL(file.file)
            this.showModal = true
        },
        onCloseModal() {
            this.showModal = false
        },
        onCrop() {
            const result = this.$refs.cropper.getResult()
            this.showModal = false
            this.img = result.canvas.toDataURL()
        },
        onZoomIn() {
            if(this.zoom > 0){
                this.onZoom(this.zoom - 0.1)
            }
        },
        onZoomOut() {
            if(this.zoom < 1){
                this.onZoom(this.zoom + 0.1)
            }
        }
    },
}
</script>
